// extracted by mini-css-extract-plugin
export default {"phoneNum":"PhoneNum_phoneNum__vdqHr"};